export default "__VITE_ASSET__CPAdwk7h__"